export const IMGCLUB = "/images/club.webp";
export const IMG_YOUTH_GATHERING_PLACE = "/images/youth_gathering_place.webp";
export const IMG_CAFE = "/images/cafe.webp";
export const IMG_UNIVERSITY = "/images/university.webp";
export const IMG_TTTM = "/images/shopping_mall.webp";
export const IMG_K_BOX = "/images/kbox.webp";
export const IMGDESIGN_1 =
  "/images/01046c_9c9bcfa8916949dcafff1b1e7ff94fe9~mv2.avif";
export const IMGDESIGN_2 =
  "/images/01046c_848daddc76c84106baf39e32c4635762~mv2.avif";
export const IMGDESIGN_3 =
  "/images/01046c_aef3ba021c62428898c0266b6d001d7d~mv2.avif";

export const IMG_LOGO_DNP = "/images/img_dnp.webp";
export const IMG_LOGO_CANON = "/images/img_canon.webp";
export const IMG_LOGO_PAYOS = "/images/img_payos.webp";
export const IMG_CUSTOMMER1 = "/images/customers/custommer1.webp";
export const IMG_CUSTOMMER2 = "/images/customers/custommer2.webp";
export const IMG_CUSTOMMER3 = "/images/customers/custommer3.webp";
export const IMG_CUSTOMER4 = "/images/customers/customer4.webp";
export const IMG_CUSTOMER5 = "/images/customers/customer5.webp";

export const IMG_METADATA = "/images/metadata_snapbox.webp";

export const IMG_SNAPBOX_OUTSIDE1 = "/images/snapbox_outside_1.webp";
export const IMG_SNAPBOX_OUTSIDE2 = "/images/snapbox_outside_2.webp";
export const IMG_SNAPBOX_OUTSIDE3 = "/images/snapbox_outside_3.webp";
export const IMG_SNAPBOX_OUTSIDE4 = "/images/snapbox_outside_4.webp";

export const IMG_PROMOTION_3112 = "/images/img_promotion_3112.webp";

export const IMG_EBOOK = "/images/ebook.webp";
export const IMG_SCREEN_STEP1 = "/images/screen_steps/screen_step1.webp";
export const IMG_SCREEN_STEP2 = "/images/screen_steps/screen_step2.webp";
export const IMG_SCREEN_STEP3 = "/images/screen_steps/screen_step3.webp";
export const IMG_SCREEN_STEP4 = "/images/screen_steps/screen_step4.webp";
export const IMG_SCREEN_STEP5 = "/images/screen_steps/screen_step5.webp";
export const IMG_SCREEN_STEP6 = "/images/screen_steps/screen_step6.webp";

export const IMG_FILTER_BLACKN_WHITE = "/images/filter_backn_white.webp";
export const IMG_FILTER_COLOR = "/images/filter_color.webp";

export const IMG_GIAM_DOC_VAN_HANH = "/images/giamdocvanhanh.webp";
export const IMG_GIAM_DOC_KHACH_HANG =
  "/images/giamdoctrainghiemkhachhang.webp";
export const IMG_GIAM_DOC_DIEU_HANH = "/images/giamdocdieuhanh.webp";
export const IMG_GIAM_DOC_DU_AN = "/images/giamdocduan.webp";
export const IMG_GIAM_DOC_KY_THUAT = "/images/giamdockythuat.webp";
export const IMG_DO_THANH_HIEN = "/images/dothanhhien.webp";
export const IMG_NGUYEN_THU_TRUNG = "/images/nguyenthuductrung.webp";
export const IMG_NGUYEN_TRUNG_SON = "/images/nguyentrungson.webp";
export const IMG_NGUYEN_VIET_ANH = "/images/nguyenvietanh.webp";
export const IMG_VU_THANH_TUNG = "/images/vuthanhtung.webp";
export const IMG_VAN_DUC_HAI_TRUNG = "/images/vanduchaitrung.webp";
export const IMG_PHI_HUYEN_TRANG = "/images/phihuyentrang.webp";
export const IMG_PHAN_HUY_CONG = "/images/phanhuycong.webp";
export const IMG_NGUYEN_TRONG_DANH = "/images/nguyentrongdanh.webp";
export const logo_partner = {
  partnerPicme: "/images/partners/img_partner_picme.webp",
  partnerKa: "/images/partners/img_partner_ka.webp",
  partnerLaikaAnBinh: "/images/partners/img_partner_laika_an_binh.webp",
  partnerLYND: "/images/partners/img_partner_lynd.webp",
  partnerMay: "/images/partners/img_partner_may.webp",
  partnerMetroStation: "/images/partners/img_partner_metro_station.webp",
  partnerMiA: "/images/partners/img_partner_mia.webp",
  partnerMPhotoBooth: "/images/partners/img_partner_m_photo_booth.webp",
  partnerPhotoCloud: "/images/partners/img_partner_photo_cloud.webp",
  partnerPhotoGorgeous: "/images/partners/img_partner_photo_gorgeous.webp",
  partnerPhotoC: "/images/partners/img_partner_photo_c.webp",
  partnerPhotosnap: "/images/partners/img_partner_photosnap.webp",
  partnerSnapTalk: "/images/partners/img_partner_snapTalk.webp",
  partnerSweet: "/images/partners/img_partner_sweet.webp",
  partnerWynAnh: "/images/partners/img_partner_wyn_anh.webp",
  partnerTach: "/images/partners/img_partner_tach.webp",
  partnerKasfi: "/images/partners/img_partner_kasfi.webp",
  partnerPhotoWink: "/images/partners/img_partner_photo_wink.webp",
  img_partner_memory: "/images/partners/img_partner_memory.webp",
  partnerBlackWhiteBoldModernStudio:
    "/images/partners/img_partner_black_white_bold_modern_studio.webp",
  partnerLogo02: "/images/partners/img_partner_logo02.webp",
  img_partner_chuu: "/images/partners/img_partner_chuu.webp",
  img_partner_giang_bui: "/images/partners/img_partner_giang_bui.webp",
  img_partner_photo_sweet: "/images/partners/img_partner_photo_sweet.webp",
  img_partner_photo_call: "/images/partners/img_partner_photo_call.webp",
  img_partner_dreamy: "/images/partners/img_partner_dreamy.webp",
  img_partner_anh_nguyet: "/images/partners/img_partner_anh_nguyet.webp",
  img_partner_photo_lovely: "/images/partners/img_partner_photo_lovely.webp",
  img_partner_hi: "/images/partners/img_partner_hi.webp",
  img_partner_kem: "/images/partners/img_partner_kem.webp",
  img_partner_picpal: "/images/partners/img_partner_picpal.webp",
  img_partner_qan: "/images/partners/img_partner_qan.webp",
  img_partner_paliko_photobooth:
    "/images/partners/img_partner_paliko_photobooth.webp",
  img_partner_photobee: "/images/partners/img_partner_photobee.webp",
  img_partner_a_little_cute: "/images/partners/img_partner_a_little_cute.webp",
  img_partner_pencil_photo: "/images/partners/img_partner_pencil_photo.webp",
  img_partner_memory_film: "/images/partners/img_partner_memory_film.webp",
  img_partner_theuni_photobooth:
    "/images/partners/img_partner_theuni_photobooth.webp",
  img_partner_vanh_photobooth:
    "/images/partners/img_partner_vanh_photobooth.webp",
  img_partner_photo_sun: "/images/partners/img_partner_photo_sun.webp",
  img_partner_pen_house_photobooth:
    "/images/partners/img_partner_pen_house_photobooth.webp",
  img_partner_caramel_click: "/images/partners/img_partner_caramel_click.webp",
  img_partner_photo_date: "/images/partners/img_partner_photo_date.webp",
  img_partner_ruby_photobooth:
    "/images/partners/img_partner_ruby_photobooth.webp",
  img_partner_paparazzi: "/images/partners/img_partner_paparazzi.webp",
  img_partner_choo_choo: "/images/partners/img_partner_choo_choo.webp",
  img_partner_daisy_photobooth: "/images/partners/img_partner_daisy_photobooth.webp",
  img_partner_róse_photobooth: "/images/partners/img_partner_róse_photobooth.webp",
  img_partner_dear_baby: "/images/partners/img_partner_dear_baby.webp",
  img_partner_lach_tach: "/images/partners/img_partner_lach_tach.webp",
  img_partner_moonie_photobooth: "/images/partners/img_partner_moonie_photobooth.webp",
};
export const tiktok_thumbnail = {
  tiktok_thumbnail1: "/images/tiktok_thumbnails/tiktok_thumbnail1.webp",
  tiktok_thumbnail2: "/images/tiktok_thumbnails/tiktok_thumbnail2.webp",
  tiktok_thumbnail3: "/images/tiktok_thumbnails/tiktok_thumbnail3.webp",
  tiktok_thumbnail4: "/images/tiktok_thumbnails/tiktok_thumbnail4.webp",
  tiktok_thumbnail5: "/images/tiktok_thumbnails/tiktok_thumbnail5.webp",
  tiktok_thumbnail6: "/images/tiktok_thumbnails/tiktok_thumbnail6.webp",
  tiktok_thumbnail7: "/images/tiktok_thumbnails/tiktok_thumbnail7.webp",
  tiktok_thumbnail8: "/images/tiktok_thumbnails/tiktok_thumbnail8.webp",
  tiktok_thumbnail9: "/images/tiktok_thumbnails/tiktok_thumbnail9.webp",
  tiktok_thumbnail10: "/images/tiktok_thumbnails/tiktok_thumbnail10.webp",
  tiktok_thumbnail11: "/images/tiktok_thumbnails/tiktok_thumbnail11.webp",
  tiktok_thumbnail12: "/images/tiktok_thumbnails/tiktok_thumbnail12.webp",
  tiktok_thumbnail13: "/images/tiktok_thumbnails/tiktok_thumbnail13.webp",
};
export const img_event = {
  event1: "/images/event/event_img1.webp",
  event2: "/images/event/event_img2.webp",
  event3: "/images/event/event_img3.webp",
};
export const img_sponsor = {
  sponsor1: "/images/event/sponsor_img1.webp",
  sponsor2: "/images/event/sponsor_img2.webp",
  sponsor3: "/images/event/sponsor_img3.webp",
};
export const img_event1 = {
  event1: "/images/event/even1_img1.webp",
};
export const img_snapapp = {
  event1: "/images/event/snap_app.webp",
};

export const listImagesFiltered = [
  {
    imageSrc: IMG_FILTER_COLOR,
    altText: "filter-color",
  },
  {
    imageSrc: IMG_FILTER_BLACKN_WHITE,
    altText: "filter-black-and-white",
  },
];
